/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp4 } from './commonProp4';

export const cots : {[key: string]: Array<[string, string]>} = {
    p_type: [
        ["WOODEN_COTS", "D\u0159ev\u011bn\u00e1"],
        ["METAL_BEDS", "Kovov\u00e9"],
        ["BUNK_BEDS", "Patrov\u00e1"],
        ["TRAVEL_COTS", "Cestovn\u00ed"],
        ["BOX_COTS", "Ohr\u00e1dky"],
        ["MATTRESS", "Matrace"],
        ["BED_SHEETS", "Povle\u010den\u00ed, prost\u011bradla, pol\u0161t\u00e1\u0159e, pe\u0159iny"],
        ["COT_NESTS", "Hn\u00edzde\u010dko"],
        ["SAFETY_BARRIER", "Bezpe\u010dnostn\u00ed z\u00e1brana"],
        ["POSITIONING_ROLLERS", "Polohovac\u00ed v\u00e1le\u010dky apod."],
        ["WEDGE_PILLOW", "Kl\u00edny do post\u00fdlky, podhlavn\u00ed\u010dky"],
        ["COT_ACCESSORIES", "P\u0159\u00edslu\u0161enstv\u00ed"],
    ],
    p_width_ordinal: [
        d("30"),
        d("35"),
        d("40"),
        d("45"),
        d("50"),
        d("55"),
        d("60"),
        d("65"),
        d("70"),
        d("75"),
        d("80"),
        d("85"),
        d("90"),
        d("95"),
        d("100"),
        d("110"),
        d("120"),
        d("130"),
        d("135"),
        d("140"),
        d("150"),
        d("160"),
        d("170"),
        d("180"),
        ["SIZE_OTHER", "Jin\u00e1"],
    ],
    p_length_ordinal: [
        d("30"),
        d("40"),
        d("50"),
        d("60"),
        d("70"),
        d("80"),
        d("90"),
        d("100"),
        d("110"),
        d("120"),
        d("130"),
        d("135"),
        d("140"),
        d("150"),
        d("160"),
        d("170"),
        d("180"),
        d("190"),
        d("200"),
        d("210"),
        d("220"),
        ["SIZE_OTHER", "Jin\u00e1"],
    ],
    p_color: commonProp4,
};
